import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M9 9.019v-4.5m0 4.5H4.5m4.5 0-5.25-5.25M9 15.019v4.5m0-4.5H4.5m4.5 0-5.25 5.25M15 9.019h4.5m-4.5 0v-4.5m0 4.5 5.25-5.25M15 15.019h4.5m-4.5 0v4.5m0-4.5 5.25 5.25"
    }, null, -1)
  ])))
}
export default { render: render }